import styled from 'styled-components';
import mainColors from '../../main-colors';
import sizeStandards from '../../size-standards';

const InputWrapper = styled.input.withConfig({
  shouldForwardProp: (prop) =>
    prop !== 'error' && prop !== '$styleType' && prop !== 'hideButtons',
})`
  width: 100%;
  height: 41px;
  padding: 0 8px;
  box-sizing: border-box;

  border-radius: 8px;
  outline: none;
  font-size: ${sizeStandards.font.SM}px;
  background-color: transparent;
  border: 2px solid ${mainColors.main_color};
  color: ${({ disabled }) =>
    disabled ? mainColors.text_color_disabled : mainColors.text_color};

  &:focus {
    box-shadow: 0 0 8px 0 ${mainColors.text_color};
  }

  ${({ $styleType }) =>
    $styleType === 'number' &&
    `
      max-width: 120px;
      padding: 0 24px; 
      text-align: center;
      /* Webkit (Chrome, Safari, Edge) spin buttons */
      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none; /* remove default arrows */
        margin: 0;
      }

      /* Firefox - remove arrows */
      -moz-appearance: textfield;
    `}

  ${({ $styleType }) =>
    $styleType === 'time' &&
    `
      text-align: center;
      border: 1px solid ${mainColors.main_color};

      &::-webkit-calendar-picker-indicator {
         display: none;
       }

         @media only screen and (max-width: ${sizeStandards.screen.SM}px) {
            padding: 0 4px;
           }

      &:focus-within {
          &::-webkit-datetime-edit-hour-field,
          &::-webkit-datetime-edit-minute-field {
               color: ${mainColors.text_color};
            }
        }
    `}

    ${({ $styleType }) =>
    $styleType === 'date' &&
    `
      font-size: ${sizeStandards.font.SM}px;
      width: 110px;

       &::placeholder {
          font-size: ${sizeStandards.font.XS}px;
          color: ${mainColors.addOpacityTo(mainColors.text_color, 0.6)};
        }
    `}
`;

export default InputWrapper;
